function PrivacyPolicyPage() {
  return (
    <div className="page">
      <h1 className="page-title">Privacy Policy</h1>

      <div className="page-section">
        <p>
          Nuvolem Software Solutions ("Nuvolem", "we", "us") respects your privacy.
          This policy explains what information we collect, how we use it, and the
          choices you have.
        </p>
        <p>
          <strong>Information we collect.</strong> When you sign in, we receive basic
          account details from Microsoft Entra ID (such as your name and email address)
          to authenticate you and manage your licenses. We do not sell your personal
          information.
        </p>
        <p>
          <strong>How we use information.</strong> We use your information to provide and
          maintain our services, manage license and seat assignments, respond to your
          requests, and improve our products.
        </p>
        <p>
          <strong>Data retention.</strong> We retain account and license information for
          as long as your account is active or as needed to provide our services and meet
          our legal obligations.
        </p>
        <p>
          <strong>Contact.</strong> If you have questions about this policy or your data,
          please reach out through our Contact page.
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
